var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.consultar.apply(null, arguments)
        }
      }
    },
    [
      _c("div", { staticClass: "layout" }, [
        _c("div", { staticClass: "layout__header" }, [
          _c("div", { staticClass: "layout__title" }, [
            _c("h3", [_vm._v(_vm._s(_vm.$t("message.consultaContenedores")))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "form-inline" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field select2-field--stretch" },
                      [
                        _c("v-select", {
                          attrs: {
                            tooltip:
                              _vm.selectedPatio !== null
                                ? _vm.selectedPatio.nombre
                                : null,
                            options: _vm.patios,
                            label: "name",
                            id: "patio",
                            placeholder: "Seleccione..."
                          },
                          on: { input: _vm.inputPatio },
                          model: {
                            value: _vm.selectedPatio,
                            callback: function($$v) {
                              _vm.selectedPatio = $$v
                            },
                            expression: "selectedPatio"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "linea" } }, [
                          _vm._v("Patio")
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.consultarEstimados,
                          expression: "consultarEstimados"
                        }
                      ],
                      attrs: { for: "garita" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_estado,
                            expression: "form.tipo_estado"
                          }
                        ],
                        attrs: {
                          value: "G",
                          type: "radio",
                          name: "tipo_estado",
                          id: "garita"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.tipo_estado, "G")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "tipo_estado", "G")
                            },
                            _vm.consultar
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("message.gate_in")))])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.consultarEstimados,
                          expression: "consultarEstimados"
                        }
                      ],
                      attrs: { for: "estimados" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_estado,
                            expression: "form.tipo_estado"
                          }
                        ],
                        attrs: {
                          value: "I",
                          type: "radio",
                          name: "tipo_estado",
                          id: "estimados"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.tipo_estado, "I")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "tipo_estado", "I")
                            },
                            _vm.consultar
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("message.estimados")))])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.consultarReparaciones,
                          expression: "consultarReparaciones"
                        }
                      ],
                      attrs: { for: "reparados" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_estado,
                            expression: "form.tipo_estado"
                          }
                        ],
                        attrs: {
                          value: "R",
                          type: "radio",
                          name: "tipo_estado",
                          id: "reparados"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.tipo_estado, "R")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "tipo_estado", "R")
                            },
                            _vm.consultar
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("message.reparados")))])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.consultarSalidas,
                          expression: "consultarSalidas"
                        }
                      ],
                      attrs: { for: "despachados" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_estado,
                            expression: "form.tipo_estado"
                          }
                        ],
                        attrs: {
                          value: "S",
                          type: "radio",
                          name: "tipo_estado",
                          id: "despachados"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.tipo_estado, "S")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "tipo_estado", "S")
                            },
                            _vm.consultar
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("message.despachados")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.por_numero_contenedor,
                          expression: "!form.por_numero_contenedor"
                        }
                      ],
                      attrs: { for: "tipoFecha" }
                    },
                    [_vm._v(_vm._s(_vm.$t("message.tipoFecha")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.por_numero_contenedor,
                          expression: "!form.por_numero_contenedor"
                        }
                      ],
                      attrs: { for: "hoy", id: "tipoFecha" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_fecha,
                            expression: "form.tipo_fecha"
                          }
                        ],
                        attrs: { value: "H", type: "radio", id: "hoy" },
                        domProps: { checked: _vm._q(_vm.form.tipo_fecha, "H") },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "tipo_fecha", "H")
                            },
                            _vm.borrarFechas
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("message.hoy")))])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.por_numero_contenedor,
                          expression: "!form.por_numero_contenedor"
                        }
                      ],
                      attrs: { for: "ayer" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_fecha,
                            expression: "form.tipo_fecha"
                          }
                        ],
                        attrs: { value: "A", type: "radio", id: "ayer" },
                        domProps: { checked: _vm._q(_vm.form.tipo_fecha, "A") },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "tipo_fecha", "A")
                            },
                            _vm.borrarFechas
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("message.ayer")))])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.por_numero_contenedor,
                          expression: "!form.por_numero_contenedor"
                        }
                      ],
                      attrs: { for: "personalizadas" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_fecha,
                            expression: "form.tipo_fecha"
                          }
                        ],
                        attrs: {
                          value: "P",
                          type: "radio",
                          id: "personalizadas"
                        },
                        domProps: { checked: _vm._q(_vm.form.tipo_fecha, "P") },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "tipo_fecha", "P")
                            },
                            _vm.changePersonalizadas
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("message.customDate")))])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "numeroContenedor" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.por_numero_contenedor,
                          expression: "form.por_numero_contenedor"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        name: "numeroContenedor",
                        id: "numeroContenedor"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.form.por_numero_contenedor)
                          ? _vm._i(_vm.form.por_numero_contenedor, null) > -1
                          : _vm.form.por_numero_contenedor
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.form.por_numero_contenedor,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "por_numero_contenedor",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "por_numero_contenedor",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "por_numero_contenedor", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("message.filterContainer")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.por_numero_contenedor,
                          expression: "form.por_numero_contenedor"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                placeholder: "#####",
                                id: "numero_contenedor"
                              },
                              model: {
                                value: _vm.form.numero_contenedor,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "numero_contenedor", $$v)
                                },
                                expression: "form.numero_contenedor"
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.numeroContenedor")) +
                                  "\n                    "
                              ),
                              _vm.errores.numero_contenedor
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.numero_contenedor[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn-info",
                              attrs: { type: "submit" },
                              on: { click: _vm.consultar }
                            },
                            [_c("i", { staticClass: "fa fa-search" })]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.form.por_numero_contenedor,
                    expression: "!form.por_numero_contenedor"
                  }
                ],
                staticClass: "row"
              },
              [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "form-inline" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.tipo_fecha === "P",
                            expression: "form.tipo_fecha === 'P'"
                          }
                        ],
                        staticClass: "form-field"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                type: "date",
                                format: "dd-MM-yyyy",
                                id: "desde",
                                lang: "es"
                              },
                              model: {
                                value: _vm.form.desde,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "desde", $$v)
                                },
                                expression: "form.desde"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("message.desde")))
                            ]),
                            _vm._v(" "),
                            _vm.errores.desde
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.errores.desde[0]))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.tipo_fecha === "P",
                            expression: "form.tipo_fecha === 'P'"
                          }
                        ],
                        staticClass: "form-field"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                type: "date",
                                format: "dd-MM-yyyy",
                                id: "hasta",
                                lang: "es"
                              },
                              model: {
                                value: _vm.form.hasta,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "hasta", $$v)
                                },
                                expression: "form.hasta"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("message.hasta")))
                            ]),
                            _vm._v(" "),
                            _vm.errores.hasta
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.errores.hasta[0]))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                placeholder: _vm.$t("message.buscar"),
                                id: "consultar"
                              },
                              model: {
                                value: _vm.form.search,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "search", $$v)
                                },
                                expression: "form.search"
                              }
                            },
                            [
                              _vm.errores.search
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.search[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(0)
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("message.numeroContenedor")))
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.$t("message.fecha")))]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.$t("message.cliente")))]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.$t("message.patio")))]),
                        _vm._v(" "),
                        _c("th", [_vm._v("U. Garita")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("U. Inspección")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("F. Insp. Caja")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("F. Insp. Máquina")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("F. Est. Caja")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("F. Est. Máquina")]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.$t("message.eirCaja")))]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("message.eirMaquina")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.tipo_estado !== "D" &&
                                  _vm.form.tipo_estado !== "G" &&
                                  _vm.form.tipo_estado !== "S",
                                expression:
                                  "form.tipo_estado !== 'D' && form.tipo_estado !== 'G' && form.tipo_estado !== 'S'"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm.$t("message.caja")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.tipo_estado !== "D" &&
                                  _vm.form.tipo_estado !== "G" &&
                                  _vm.form.tipo_estado !== "S",
                                expression:
                                  "form.tipo_estado !== 'D' && form.tipo_estado !== 'G' && form.tipo_estado !== 'S'"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm.$t("message.maquina")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.tipo_estado === "D" &&
                                  _vm.form.tipo_estado !== "G" &&
                                  _vm.form.tipo_estado !== "S",
                                expression:
                                  "form.tipo_estado === 'D' && form.tipo_estado !== 'G' && form.tipo_estado !== 'S'"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm.$t("message.digitado")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.tipo_estado === "S",
                                expression: "form.tipo_estado === 'S'"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm.$t("message.despachado")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.tipo_estado === "G",
                                expression: "form.tipo_estado === 'G'"
                              }
                            ]
                          },
                          [_vm._v("Gate IN")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.inspecciones, function(inspeccion, index) {
                        return _c("item-inspeccion", {
                          key: index,
                          tag: "tr",
                          attrs: {
                            inspeccion: {
                              fecha: inspeccion.gate_in_date,
                              numero_contenedor: inspeccion.number,
                              eir_caja_in: inspeccion.eir_in,
                              eir_maquina_in: inspeccion.eir_maquina_in,
                              inspeccion_finalizada_c:
                                (_vm.form.tipo_estado === "G" &&
                                  inspeccion.garita_finalizada === "S") ||
                                (_vm.form.tipo_estado === "I" &&
                                  inspeccion.inspection_b === "S") ||
                                (_vm.form.tipo_estado === "E" &&
                                  inspeccion.estimado_caja === "S") ||
                                (_vm.form.tipo_estado === "R" &&
                                  inspeccion.repaired === "S") ||
                                (_vm.form.tipo_estado === "D" &&
                                  inspeccion.digitado === "S") ||
                                (_vm.form.tipo_estado === "S" &&
                                  inspeccion.kim_salida === "S"),
                              inspeccion_finalizada_m:
                                (_vm.form.tipo_estado === "G" &&
                                  inspeccion.garita_finalizada === "S") ||
                                (_vm.form.tipo_estado === "I" &&
                                  inspeccion.inspection_m === "S") ||
                                (_vm.form.tipo_estado === "E" &&
                                  inspeccion.estimado_maquina === "S") ||
                                (_vm.form.tipo_estado === "R" &&
                                  inspeccion.repaired_m === "S") ||
                                (_vm.form.tipo_estado === "D" &&
                                  inspeccion.digitado === "S") ||
                                (_vm.form.tipo_estado === "S" &&
                                  inspeccion.kim_salida === "S"),
                              cliente: inspeccion.customer.name,
                              patio:
                                inspeccion.yard !== null
                                  ? inspeccion.yard.name
                                  : "",
                              usuarioFinalizacion: inspeccion.cod_usuario_insp,
                              usuario_garita: inspeccion.usuario_garita_fin,
                              date_i_m: inspeccion.date_i_m,
                              date_i_b: inspeccion.date_i_b,
                              fecha_e_maquina: inspeccion.date_e_m,
                              fecha_e_caja: inspeccion.date_e_b
                            },
                            tipoEstado: _vm.form.tipo_estado,
                            estado: _vm.form.tipo_estado,
                            bloqueadoMaquina: false,
                            bloqueadoCaja: false
                          }
                        })
                      }),
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn-info", attrs: { type: "submit" } },
      [_c("i", { staticClass: "fa fa-search" })]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-748ec8ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748ec8ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inspeccion/ConsultaInspecciones.vue
// module id = 370
// module chunks = 0